// 編輯作者頁 - 作者文章列表
'use client';
import { useState, useEffect } from 'react';

import ListComponent from '../list/ListComponent'; // 列表新聞元件
import Pagination from '../layout/Pagination'; // 分頁功能列

import { findReporterNewsByCode } from '@/app/actions'; // 取得文章列表

const AuthorArticleList = ({ locale, reporterCode, initList, pageSize }) => {
    console.log(initList);

    const [isMount, setIsMount] = useState(false);
    // 列表內容
    const [newsList, setNewsList] = useState(initList);
    // 頁碼
    const [pageIndex, setPageIndex] = useState(1);

    // 取得更多新聞
    const fetchFindReporterNewsByCode = async () => {
        try {
            const { data } = await findReporterNewsByCode(locale, reporterCode, pageIndex, 20);

            if (data?.records) {
                window.scrollTo({ top: 0 });
                setNewsList(data?.records);
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (isMount) fetchFindReporterNewsByCode();
        setIsMount(true);
    }, [pageIndex]);

    return (
        <section className="w-full">
            <div
                className={`space-y-[5px] ulg:space-y-[40px] usm:!space-y-[24px]
            ${newsList?.length < 3 || pageSize < 2 ? 'pb-[50px]' : ''}`}
            >
                {newsList?.map((item, i) => (
                    <ListComponent key={`author-list-${i}`} info={item} />
                ))}
            </div>

            {/* 分頁功能列 */}
            <Pagination pageIndex={pageIndex} setPageIndex={setPageIndex} pageSize={pageSize} />
        </section>
    );
};

export default AuthorArticleList;
